import { Alert, Button, type ButtonProps } from "@mui/material";
import { DefaultButtonIcon } from "../../icon/Icon";
import { Trans } from "react-i18next";
import { IconType } from "../../icon/IconType";
import { useSchaefflerForm } from "~/CMSComponents/components/SchaefflerForm/useSchaefflerForm";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { Dialog, DialogContent, DialogHeader } from "~/common/m3/Dialog/Dialog";
import { ProductContext } from "~/feature/Product/ProductContext";
import type { ProductData } from "~/models/ProductData";
import { useTranslation } from "react-i18next";
import { Snackbar } from "~/common/m3/Snackbar/Snackbar";
import { useState } from "react";

type Props = ButtonProps & {
  product: ProductData;
};

const EWELLIX_FORM_ID = "SchaefflerForm-PDP";

export const useEwellixContactForm = (_: ProductData) => {
  const { t } = useTranslation();
  // TODO - this snackbar is double from SchaefflerForm.tsx - how to improve this?
  const [showSnackbar, setShowSnackbar] = useState(false);
  const { val: isOpen, setTrue: open, setFalse: close } = useBooleanState(false);
  const { renderForm, loading, loadForm } = useSchaefflerForm(EWELLIX_FORM_ID, () => {
    setShowSnackbar(true);
    close();
  });

  const onClick = () => loadForm().then(open);
  const dialog = (
    <>
      <Dialog open={isOpen} onClose={close} maxWidth="desktop-s">
        <DialogHeader onClose={close} />
        <DialogContent>{renderForm()}</DialogContent>
      </Dialog>
      <Snackbar open={showSnackbar} onClose={() => setShowSnackbar(false)}>
        <Alert severity="success" onClose={() => setShowSnackbar(false)} sx={{ boxShadow: 2 }}>
          {t("feature.cmsContactForm.success")}
        </Alert>
      </Snackbar>
    </>
  );

  return {
    onClick,
    dialog,
    loading,
  };
};

export const EwellixRequestAQuoteButton = ({ product, ...props }: Props) => {
  const { onClick, loading, dialog } = useEwellixContactForm(product);
  return (
    <ProductContext value={product}>
      <Button
        startIcon={<DefaultButtonIcon type={IconType.FileList} />}
        fullWidth={true}
        data-test-id={"requestAQuote"}
        loading={loading}
        {...props}
        onClick={onClick}
      >
        <Trans i18nKey={"cartPage.btn.quote"} />
      </Button>
      {dialog}
    </ProductContext>
  );
};
